

const Visit = () => {


  return (
    <>
    <section className=" container-fluid " id="menu">
        <section className="container  ">
            <section className="row text-center  py-5">
                <div className="col-12 text-center ">
                    <h2>GET YOUR FIRST TRIAL VISIT</h2>
                    <p className="mt-3">Nulla in eget tortor morbi enim maecenas aenean viverra  Sodales suscipit nunc <br />elit arcu,
                        pulvinar. Vestibulum enim eget vulputate tempus lacu.</p>

                        <div class="input-group mb-3 w-25 mx-auto">
                        <input type="text" class="form-control" placeholder="Recipient's username" aria-label="Recipient's username" aria-describedby="button-addon2"/>
                        <button class="btn btn-outline-secondary" type="button" id="button-addon2">Submit</button>
                        </div>
                    
                </div>
            </section>
        </section>
    </section>  
    
    </> 
  );
  

};

export default Visit;
